<template>
  <div>
    <ul class="record-list">
      <li class="item" v-for="(item, index) in recordLists" :key="index">
        <div class="title-box">
          <p class="date">
            <i class="iconfont iconshijian00"></i>
            <span class="span">{{ item.created_at }}</span>
          </p>
          <p class="title">
            <span class="span">[{{ item.type_title }}]</span>
            <span class="tit">{{ item.title }}</span>
          </p>
        </div>

        <div class="progress-box">
          <!--<div class="progress">
            <el-progress
              :percentage="(item.score/item.sum_score)*100"
              :showText="false"
            />
          </div>-->
          <span class="primary">已做：{{ item.fulfil_number }}</span
          >/
          <span>总题：{{ item.subject_total }}</span>

          <span class="primary" style="margin-left: 20px;">得分：{{ item.score }}</span
          >/
          <span>总分：{{ item.sum_score }}</span>
        </div>

        <div class="link-box">
          <span
            v-if="item.doneNum == item.topicAllNum"
            class="link"
            @click="jumpAnalysis(item)"
            >查看解析</span
          >
          <el-button type="primary" class="link-btn" @click="jump(item)">{{
            item.is_submit === 2 ? "重新做题" : "继续做题"
          }}</el-button>
          <!-- <el-button v-else type="primary" class="link-btn" @click="jump(item)"
            >继续做题</el-button
          > -->
        </div>
      </li>
    </ul>

    <div style="margin: 20px 0;text-align: right;" v-if="total > 0">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pageInfo.page"
        :total="total"
        :page-size="pageInfo.limit"
        :page-sizes="[10, 20, 30, 50, 100]"
        @current-change="currentChange"
        @size-change="sizeChange"
      >
      </el-pagination>
    </div>

    <ComponentEmpty
      v-if="recordLists.length == 0"
      title="暂无做题记录"
      tips=""
    />
  </div>
</template>

<script>
import { getTopicRecords } from "@/api/record";
import { setStore } from "@/utils/localStorage";
export default {
  name: "problem",
  data() {
    return {
      pageInfo: {
        page: 1,
        limit: 10,
      },
      total: 0,
      recordLists: [],
    };
  },
  created() {
    this.getTopicRecords();
  },
  methods: {
    /**
     *  分页 页码改变
    */
    currentChange(v){
      this.getTopicRecords();
    },
    /**
     * 分页 每页数量改变
     */
    sizeChange(v){
      this.pageInfo.limit = v;
      this.getTopicRecords();
    },
    /**
     * 获取做题记录
     */
    async getTopicRecords() {
      let data = this.pageInfo;
      const res = await getTopicRecords(data);
      if (res.code === 200) {
        this.total = res.result.total
        this.recordLists = res.result.list;

      }
    },
    /**
     * 查看解析
     */
    jumpAnalysis(item) {
      this.$router.push({
        name: "practiceAnalysis",
        query: {
          make_id: item.id,
        },
      });
      // if (item.isExercise) {
      //
      // } else {
      //   this.$router.push({
      //     name: "testAnalysis",
      //     query: {
      //       paperUuid: item.uuid,
      //     },
      //   });
      // }
    },
    /**
     * 继续做题/重新做题
     */
    jump(item) {

      if(item.test_id>0) {        
        if(item.is_submit == 2){
          if(item.is_exam == 1){            
            this.$router.push({
              name: "onlineTest",
              query: {           
                test_id: item.test_id,
              }
            });
          }else{
            this.$router.push({
              name: "smartPractice",
              query: {           
                test_id: item.test_id,
                course_id:item.course_id
              }
            });
          }
        }else{
          if(item.is_exam == 1){
            this.$router.push({
              name: "onlineTest",
              query: {           
                make_id: item.id,
              }
            });
          }else{
            this.$router.push({
              name: "smartPractice",
              query: {           
                make_id: item.id,
              }
            });
          }          
        }
        
        return;
      }
      if(item.make_type === 2){
        if(item.is_submit == 2){
          this.$router.push({
            name: "startPractice",
            query: {
              section_id: item.section_id,
              course_id:item.course_id
            }
          });
        }else{
          this.$router.push({
            name: "startPractice",
            query: {
              make_id: item.id,
            }
          });
        }
        return;
      }
      if(item.make_type === 1){
        if(item.is_submit == 2){
          this.$router.push({
            name: "homeWork",
            query: {
              section_id: item.section_id,
              course_id:item.course_id
            }
          });
        }else{
          this.$router.push({
            name: "homeWork",
            query: {
              make_id: item.id,
            }
          });
        }
        return;
      }

      if(item.make_type === 4){       
        if(item.is_submit == 2){
          this.$router.push({
            name: "smartPractice",
            query: {
              question_style: item.question_style,
              course_id:item.course_id,
              total: item.total,
              start:item.start,
              title:item.question_title
            }
          });
        }else{
          this.$router.push({
            name: "smartPractice",
            query: {
              make_id: item.id,
            }
          });
        }
        return;
      }

      if(item.make_type === 5){              
        if(item.is_submit == 2){
          this.$router.push({
            name: "startPractice",
            query: {
              question_title: item.question_title,
              course_id:item.course_id,             
            }
          });
        }else{
          this.$router.push({
            name: "startPractice",
            query: {
              make_id: item.id,
            }
          });
        }
        return;
      }
      // this.$store.commit("common/changeMenuMutation", { name: item.left_title });
      // this.$router.push({
      //   name: "allTest",
      // });
    },
    /**
     * 重做(需要先清空之前的做题记录)
     */
    // async reStart(item) {
    //   if (item.isExercise) {
    //     const datas = await clearCourse({
    //       uuid: item.uuid,
    //     });
    //     if (datas) {
    //       this.$router.push({
    //         name: "startPractice",
    //         query: {
    //           courseUuid: item.uuid,
    //         },
    //       });
    //     }
    //   } else {
    // let status = "";
    // if (item.doneNum == item.topicAllNum) {
    //   status = "已做过";
    // }
    // this.$router.push({
    //   name: "realTestStart",
    //   query: {
    //     uuid: item.uuid,
    //     type: 3,
    //     status: status,
    //   },
    // });
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
.record-list {
  .stem {
    display: none;
  }

  .item {
    width: 100%;
    min-height: 104px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 15px;

    &:nth-child(odd) {
      background: #f8f8f8;
    }

    .title-box {
      flex: 1 1 auto;
      margin-right: 20px;

      .date {
        color: #9a9a9a;
        .iconfont {
          margin-right: 10px;
          font-size: 25px;
          vertical-align: middle;
        }

        .span {
          &:after {
            content: " / ";
          }

          &:last-child:after {
            content: "";
          }
        }
      }

      .title {
        margin-top: 10px;
        font-size: 15px;
        display: flex;

        .span {
          @include fontColor("primary");
          margin-right: 15px;
        }

        .tit {
          flex: 1 1 auto;
        }
      }
    }

    .progress-box {
      display: flex;
      align-items: center;
      min-width: 500px;

      .progress {
        width: 180px;
        margin-right: 30px;
      }
    }

    .link-box {
      min-width: 186px;
      text-align: right;
      .link {
        cursor: pointer;
        margin-right: 20px;
        @include fontColor("primary");
      }
      .link-btn {
        @extend %uni-primary-btn;
      }
    }
  }
}
</style>
